<template lang="html">
	<button
		type="submit"
		class="omapi-button omapi-wizard-forward omapi-button__green"
		:disabled="disabled"
		v-bind="$attrs"
		v-on="$listeners"
		ref="el"
	>
		{{ text }}
	</button>
</template>
<script lang="js">
export default {
	props : {
		disabled : Boolean,
		text     : {
			type    : String,
			default : 'Next Step',
		},
	},
}
</script>
